module.exports = __webpack_public_path__ + "img/lara_loureiro.385d324f.jpeg";